import Rebase from 're-base';
import firebase from 'firebase';

var app = firebase.initializeApp({
    apiKey: "AIzaSyAdRnL-2w11fpxwD5AZ9NXrcPBtJcv8LNI",
    authDomain: "transavia-portal.firebaseapp.com",
    databaseURL: "https://transavia-portal.firebaseio.com",
    projectId: "transavia-portal",
    storageBucket: "transavia-portal.appspot.com",
    messagingSenderId: "739203910625"
});

var base = Rebase.createClass(app.database());
base.timestamp = firebase.database.ServerValue.TIMESTAMP;

export default base;
export { app as firebase };


// WEBPACK FOOTER //
// ./src/rebase.js